/* Carosello bottiglie.
   Tiene sincronizzati testo e caratteristiche con la bottiglia al centro.

   Accorgimenti nati da bug veri:
   1) gli ascoltatori stanno sul documento in fase di cattura: il tema rigenera i
      figli della sezione dopo il caricamento e dei listener agganciati ai nodi
      originali resterebbe solo il ricordo. Per lo stesso motivo qui dentro non
      si conserva nessun elenco di nodi: si interroga sempre il DOM sul momento;
   2) niente requestAnimationFrame per lo scaglionamento: nelle schede non in
      primo piano non scatta e la sincronizzazione resterebbe bloccata;
   3) ogni bottiglia e un collegamento alla sua scheda: senza una soglia di
      trascinamento, la fine di uno swipe viene letta come click e si aprirebbe
      una pagina per sbaglio. Sotto i 10px di movimento e un tocco, sopra e uno
      scorrimento;
   4) il segnale "ho trascinato" vale solo per il gesto in corso. Prima restava
      acceso a tempo indeterminato e il click successivo veniva annullato con
      stopPropagation: era questo a mangiare il primo tocco. Ora il gesto si
      chiude su pointerup/touchend e il segnale scade dopo mezzo secondo;
   5) il collegamento si apre solo dalla bottiglia gia' al centro. Sulle
      laterali il click le porta al centro, come faceva prima: chi scorre non
      apre mai niente per sbaglio e non si perde il modo di scegliere la
      bottiglia guardandola. */
(function () {
  var SOGLIA = 10;
  var FINESTRA = 500;

  function scarto(el, scroller) {
    var r = el.getBoundingClientRect();
    var rs = scroller.getBoundingClientRect();
    return (r.left + r.width / 2) - (rs.left + rs.width / 2);
  }

  function scorriVerso(b, morbido) {
    var v = b.closest('[data-vetrina]');
    if (!v) return;
    var scroller = v.querySelector('[data-scroller]');
    if (!scroller) return;
    var d = scarto(b, scroller);
    if (Math.abs(d) < 2) return;
    try {
      scroller.scrollBy({ left: d, behavior: morbido ? 'smooth' : 'auto' });
    } catch (e) {
      scroller.scrollLeft += d;
    }
  }

  // Le frecce non hanno nulla da fare ai due capi: spente si capisce subito.
  function frecce(vetrina, migliore, totale) {
    var prec = vetrina.querySelector('[data-freccia="prec"]');
    var succ = vetrina.querySelector('[data-freccia="succ"]');
    if (prec) prec.disabled = migliore <= 0;
    if (succ) succ.disabled = migliore >= totale - 1;
  }

  function sincronizza(vetrina) {
    var scroller = vetrina.querySelector('[data-scroller]');
    if (!scroller) return;

    var bottiglie = vetrina.querySelectorAll('[data-bottiglia]');
    if (bottiglie.length < 2) return;

    var migliore = 0;
    var minima = Infinity;
    for (var i = 0; i < bottiglie.length; i++) {
      var d = Math.abs(scarto(bottiglie[i], scroller));
      if (d < minima) { minima = d; migliore = i; }
    }

    frecce(vetrina, migliore, bottiglie.length);

    if (String(migliore) === vetrina.dataset.indice) return;
    vetrina.dataset.indice = String(migliore);

    var pannelli = vetrina.querySelectorAll('[data-pannello]');
    var dati = vetrina.querySelectorAll('[data-dati]');

    for (var j = 0; j < pannelli.length; j++) {
      var attivo = j === migliore;
      pannelli[j].classList.toggle('is-attivo', attivo);
      if (attivo) pannelli[j].removeAttribute('aria-hidden');
      else pannelli[j].setAttribute('aria-hidden', 'true');
    }
    for (var k = 0; k < dati.length; k++) dati[k].classList.toggle('is-attivo', k === migliore);
    for (var m = 0; m < bottiglie.length; m++) bottiglie[m].classList.toggle('is-attivo', m === migliore);
  }

  // Un contatore per ogni vetrina: con due sezioni nella stessa pagina un
  // timer condiviso spegnerebbe quello dell'altra.
  function programma(vetrina) {
    sincronizza(vetrina);
    clearTimeout(vetrina.codaVetrina);
    vetrina.codaVetrina = setTimeout(function () { sincronizza(vetrina); }, 120);
  }

  function vetrinaDi(nodo) {
    if (!nodo || !nodo.closest) return null;
    return nodo.closest('[data-vetrina]');
  }

  function tutteLeVetrine() {
    return document.querySelectorAll('[data-vetrina]');
  }

  // Lo scorrimento non risale la gerarchia: serve la fase di cattura.
  document.addEventListener('scroll', function (e) {
    var v = vetrinaDi(e.target);
    if (v) programma(v);
  }, true);

  // Soglia di trascinamento: distingue lo swipe dal tocco.
  var partenzaX = null;
  var partenzaY = null;
  var trascinato = false;
  var fineGesto = 0;

  function giu(x, y) { partenzaX = x; partenzaY = y; trascinato = false; }

  function muovi(x, y) {
    if (partenzaX === null) return;
    if (Math.abs(x - partenzaX) > SOGLIA || Math.abs(y - partenzaY) > SOGLIA) trascinato = true;
  }

  function su() { partenzaX = null; partenzaY = null; fineGesto = Date.now(); }

  document.addEventListener('touchstart', function (e) {
    if (!vetrinaDi(e.target)) return;
    if (!e.touches || !e.touches.length) return;
    giu(e.touches[0].clientX, e.touches[0].clientY);
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', function (e) {
    if (partenzaX === null) return;
    if (!e.touches || !e.touches.length) return;
    muovi(e.touches[0].clientX, e.touches[0].clientY);
  }, { passive: true, capture: true });

  document.addEventListener('touchend', su, { passive: true, capture: true });
  document.addEventListener('touchcancel', su, { passive: true, capture: true });

  document.addEventListener('pointerdown', function (e) {
    if (!vetrinaDi(e.target)) return;
    giu(e.clientX, e.clientY);
  }, true);

  document.addEventListener('pointermove', function (e) {
    if (partenzaX === null) return;
    muovi(e.clientX, e.clientY);
  }, true);

  document.addEventListener('pointerup', su, true);
  document.addEventListener('pointercancel', su, true);

  // Tre esiti possibili per un click sulla bottiglia:
  //   - era uno scorrimento: non succede niente, e se la bottiglia e un
  //     collegamento lo si ferma qui. E' la rete di sicurezza dello swipe;
  //   - la bottiglia e laterale: viene portata al centro, la pagina non cambia;
  //   - la bottiglia e gia al centro: si apre la sua scheda.
  // Da tastiera (Invio e Spazio danno detail 0) si va sempre alla scheda: il
  // focus ha gia portato la bottiglia al centro poco prima.
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-bottiglia]') : null;
    if (!b) return;

    var eraSwipe = trascinato && (Date.now() - fineGesto) < FINESTRA;
    trascinato = false;

    var collega = b.tagName === 'A' && !!b.getAttribute('href');

    if (eraSwipe) {
      if (collega) e.preventDefault();
      return;
    }

    if (collega && (e.detail === 0 || b.classList.contains('is-attivo'))) return;

    if (collega) e.preventDefault();
    scorriVerso(b, true);
  }, true);

  // Solo da tastiera: col mouse e col dito il focus non deve muovere la giostra.
  document.addEventListener('focusin', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-bottiglia]') : null;
    if (!b) return;
    if (partenzaX !== null || (Date.now() - fineGesto) < FINESTRA) return;
    var daTastiera = false;
    try { daTastiera = b.matches(':focus-visible'); } catch (err) { daTastiera = false; }
    if (daTastiera) scorriVerso(b, true);
  });

  var codaMisure = null;
  window.addEventListener('resize', function () {
    clearTimeout(codaMisure);
    codaMisure = setTimeout(function () {
      var tutte = tutteLeVetrine();
      for (var i = 0; i < tutte.length; i++) sincronizza(tutte[i]);
    }, 150);
  });

  // Posizione di partenza: la seconda bottiglia, cosi se ne vede una per lato.
  // Non si controlla piu' scrollLeft === 0: con lo scroll-snap il browser
  // sposta da solo la giostra prima ancora che questo script parta, e la
  // condizione non era mai vera. Basta il segno lasciato sulla vetrina.
  function inquadra() {
    var tutte = tutteLeVetrine();
    for (var i = 0; i < tutte.length; i++) {
      var v = tutte[i];
      var scroller = v.querySelector('[data-scroller]');
      if (!scroller) continue;
      var bottiglie = v.querySelectorAll('[data-bottiglia]');

      // Lo swipe orizzontale scorre la giostra, quello verticale la pagina.
      scroller.style.touchAction = 'pan-x pan-y';

      if (bottiglie.length > 2 && v.dataset.inquadrata !== 'si') {
        v.dataset.inquadrata = 'si';
        scorriVerso(bottiglie[1], false);
      }
      sincronizza(v);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inquadra);
  else inquadra();
  window.addEventListener('load', inquadra);
  document.addEventListener('shopify:section:load', inquadra);
  setTimeout(inquadra, 500);
  setTimeout(inquadra, 1500);
})();
